import * as React from 'react'
import {Link} from 'react-router-dom'
import { connect } from 'react-redux'

import { fetchSingleVisit } from  './../redux/actions/visits'
import Page from './../components/shared/page'
import ReviewSelect from './../components/review/reviewSelect'
import arrow from './../images/left-arrow-circle.png'
import './../styles/review/review.css'

var strftime = require('strftime')

class Review extends React.Component {

  componentDidMount() {
    const id = Number(this.props.match.params.id)
    this.props.fetchSingleVisit(id)
  }

  licensePlateCheck = (num) => {
    if(num === null) {
      return 'No Plate Read'
    } else {
      return num
    }
  }


  render () {
    const { visit } = this.props.visits
    return (
      <Page history={this.props.history} >
        <div className='review-header'>
        <Link to='/visits'>
          <div className='review-back'>
              <img src={arrow} alt='back arrow'/>
              <p className='review-back-text'>
                Back to search results
              </p>
            </div>
          </Link>
          <div className='review-license-plate'>
          <p id='review-license-plate'>
            <b>License:</b>
            {visit && ' ' + this.licensePlateCheck(visit.license_plate)}
          </p>
          <p>
            <b>Date:</b>
            {visit && ' ' + strftime('%D %I:%M %p', new Date(visit.triggered_at))}
          </p>
          <p>
            <b>Bay:</b>
            {visit && ' ' + visit.bay}
          </p>
          </div>
        </div>
        <div className='review-selection'>
          {visit &&
            <ReviewSelect visit={visit}/>
          }
        </div>
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch)=> {
  return {
    fetchSingleVisit: (id) => {
      return dispatch(fetchSingleVisit(id));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Review)



// WEBPACK FOOTER //
// ./src/pages/review.js